<template>
  <div>
    <h4 class="text-muted">{{$t('message.generics.message.generalData')}}</h4>
    <v-text-field :label="$t('message.generics.message.name')"
                  name="Nome"
                  v-model="val.nome"
                  v-validate="'required'"
                  @input="$emit('input', val)"></v-text-field>
    <v-text-field :label="$t('message.generics.message.email')"
                  name="E-mail"
                  v-model="val.login"
                  v-validate="'required'"
                  @input="$emit('input', val)"></v-text-field>
    <v-text-field v-if="!isPartner"
                  :label="$t('message.campaigns.message.postAuthPage')"
                  name="Página pós-autenticação"
                  v-model="val.paginaPosAutenticacao"
                  v-validate="'required'"
                  :disabled="!isMasterUser"
                  @input="$emit('input', val)"></v-text-field>
  </div>
</template>

<script>
import vModel from "@mixins/v-model";
import EventBus from "@packages/event-bus";

export default {
  methods: {
    async validate() {
      let errors;
      if (!this.val.nome) errors = this.$t('message.errorMessages.message.enterName');
      else if (!this.val.login) errors = this.$t('message.errorMessages.message.enterEmail');
      else if (!this.isPartner && !this.val.paginaPosAutenticacao)
        errors = this.$t('message.errorMessages.message.enterPostAuthPage');

      if (errors) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: errors,
        });
        return;
      }
      this.$emit("valid");
    },
  },

  computed: {
    user() {
      return this.$store.state.users.user;
    },
    isMasterUser() {
      return this.user && this.user.permissions.includes("MASTER");
    },
    isPartner() {
      return this.$store.state.users.user.tipo === "PARCEIRO";
    },
  },

  mixins: [vModel],
};
</script>

<style lang="scss" scoped>
</style>
